export const checkForValue = prop => {
  let value = !prop ? "" : prop
  return value
}
